import * as types from '../constants';

export const selectBooking = booking => ({
  type: types.SELECT_BOOKING,
  payload: booking,
});